import React from 'react';
import { FeatureCard as RawFeatureCard } from '../../../components/landingPage/FeatureCard';
import { ImageProps, Image } from '../../landingPage/Image';
import {
    SanityBlock,
    SanityObject,
    SanitySlug,
} from '../../../lib/landingPage';
import { PortableText } from '../PortableText';
import { Wrapper } from '../Wrapper';

export type FeatureCardProps = SanityObject<{
    image: SanityObject<ImageProps>;
    description: SanityBlock;
    title: string;
    subtitle: string;
    page: { slug: SanitySlug };
    buttonText: string;
}>;

export const FeatureCard = Wrapper(
    ({
        image,
        description,
        title,
        buttonText,
        page,
        subtitle,
    }: FeatureCardProps): JSX.Element => {
        return (
            <RawFeatureCard
                href={`/${page.slug.current}`}
                buttonText={buttonText}
                image={<Image value={image} />}
                title={title}
                subtitle={subtitle}>
                <PortableText value={description} />
            </RawFeatureCard>
        );
    },
    'feature'
);
